import React, { useEffect, useState } from "react";
import { PerkDetailModal } from "@plans-templates/perk-details";
import { RadioButtonGroup } from "@vds/radio-buttons";
import constants from "./constants";
import AlternateCheckmark from "@vds/icons/alternate-checkmark";
import Minus from "@vds/icons/minus";
import styled from "styled-components";
import { Title } from "@vds/typography";
import { Body } from "@vds/typography";
import { Loader } from "@vds/loaders";
import { perkLogoAlt } from "./PerksLogo";
import { connect } from "react-redux";
import { updatePerkSelection } from "../../../action/buildProduct";
import { Pricing } from "@plans/type-lockups";
import { checkNewPerksMvSeamless, InHomeUtils } from "../../../util/inhomeUtils";
import { RadioButtonlabel } from "./perkTile";
import { Button } from '@vds/buttons';
import AppleModal from "./appleModal";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { getVZDLInit, updateVzdlSCCustomEvent, tempVzdlSCData, updateSandboxIdValue, updateFragmentsValue, updateDetailValue } from  './../../../service/vzdl';
import { updateSCTags } from './../../../service/dtmTag';
import { Tilelet } from "@plans/tiles";
import { getDisneyPromoDts } from "../DiscountFlowModal";
import CloudStepDownModal from "./cloudStepDownModal";
import PerksOverlay from "../../change/buildProduct/perksOverlay";
import ReactHtmlParser from 'react-html-parser';
import { Notification } from "@vds/notifications";

const ListElement = styled.span`
  ul {
    li {
      display: list-item;
      margin-bottom: 4px !important;
    }
  }
  a:focus {
    border: 2px dotted black;
  }
`;

const Description = styled.span`
  a:focus {
    border: 2px dotted black;
  }
`;

const StyledSup = styled.sup`
  vertical-align: super !important;
`;

export function checkForGroupProdcutSelectedToOpenTheDrawer(props){
  let groupObject={'R3556':{drawer:false,defaultValue:'R3556'},'R3552':{drawer:false,defaultValue:'R3552'},"R3731":{drawer:false,defaultValue:'R3731'}};
   if(InHomeUtils.isNotNull(props?.selectedProduct) &&  InHomeUtils.isNotNull(props?.perkList) &&
       props?.selectedProduct?.length > 0
  ){
     let selectedProduct = props?.selectedProduct?.split(",");
     selectedProduct?.forEach((item)=>{ 
        if(constants.UNLIMITED_CLOUD_STORAGE.includes(item)){
          groupObject[constants.UNLIMITED_CLOUD_INDIVIDUAL]={drawer:true,defaultValue:item}
        }
        if(constants.APPLE_ONE_GROUP_IDS.includes(item)){
          groupObject[constants.APPLE_ONE_INDIVIDUAL]={drawer:true,defaultValue:item}
        }
        if(constants.PROTECT_GROUP_IDS.includes(item)){
          groupObject[constants.HOME_DEVICE_ADVISOR]={drawer:true,defaultValue:item}
        }
      })
   }
   return groupObject;
}

function PerkDetailOverlay(props) {
  const [showLoader, setLoaderStatus] = useState(false);
  const whatsIncludedKey = "What\u2019s included";
  const {
    selectedProductId,
    showModal,
    uniqPerkList,
    perkList,
    selectedPerk,
    onOpenedChange,
    onModalChange,
    perkListobj,
    variant,
    changeFn,
    toggleOn,
    // isToggleDisabled,
    selectedProduct,
    visitId, 
    flowType, 
    dispatch,
    isMnHAuthenticated,
    selectedPerks,
    isEmployee,
    perkModalName,
    setPerksOverlayState,
    buildProduct,
    isStreamline,
    movesShowPerksOverlay,
    showApplePriceUP,
    selectedGrpPerkId,
    selectedProductRadio
  } = props || {};

  useEffect(() => {
    // To set perk overlay to false so that overlay doesn't open up when Perk toggle is clicked
    return () => {
      setPerksOverlayState(false);
    }
  }, []);

  let perkIndex =
    uniqPerkList &&
    uniqPerkList?.findIndex(
      (prod) => (prod && prod?.perkDetails?.[0]?.id) == selectedProductId
    );
  let initialPerk = uniqPerkList?.[perkIndex];
  let [perkOnView, setPerkData] = useState(initialPerk && initialPerk?.data);
  const [showAppleModal,setShowAppleModal] = useState(false);
  const [exisitngAppleProduct,setExisitngAppleProduct] = useState("");
  const [showAppleInfoModal,setShowAppleInfoModal] = useState(false);
  const disneyEligiblePlans = ['R3583', 'R3582', 'R3584'];
  const isMobile = (window.screen.width < 768);

  let {
    featuresDetailsList = [],
    faqList = [],
    videoUrl = "",
    posterImage = "",
    titles = [],
    termsAndConditions = "",
    description: aboutText = "",
    price = "",
    perkOriginalPrice = "",
    productId: perkOnViewId = "",
  } = perkOnView || {};
  let perkOverlayObj = {};
  const empDiscount = isEmployee ? 5 : 0;
  let discountedPrice = (perkOriginalPrice - price + empDiscount)?.toFixed(2)?.replace(/\.00$/, '');
  let perkActPrice = perkOnView?.perkOriginalPrice;
  const perkMrp = perkOnView?.productKeyword?.split?.('MRP:')?.[1];
  if (perkMrp && !(Array.isArray(perkOnView?.groupBy) && perkOnView?.groupBy?.length > 1)) {
    perkActPrice = parseFloat(perkMrp?.split('|')?.[0]);
    discountedPrice = (perkActPrice - (isEmployee ? parseFloat(price)/2 : price))?.toFixed?.(2)?.replace?.(/\.00$/, '');
  }
  const groupPerks = checkForGroupProdcutSelectedToOpenTheDrawer(props);
  const [showDrawer,setShowDrawer] = useState(groupPerks);
  let streamdrawer={};
  function onChangeSlide(defaultValue) {
    setLoaderStatus(true);
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1000);
    let perkObj =
      uniqPerkList &&
      uniqPerkList?.[defaultValue] &&
      uniqPerkList?.[defaultValue]?.perkDetails?.[0];
    perkObj && setPerkData(perkObj);
  }
  
  const [hasCloudStepDown, setCloudStepDown] = useState(false);
  const [isCloudStepDownModalOpen, setCloudStepDownModalOpen] = useState(false);
  const [cloudStepDownSubmitData, setCloudStepDownSubmitData] = useState(null);
  const [cloudStepDownSource, setCloudStepDownSource] = useState("");

  useEffect(() => {
    const profileCartPerks = props?.profileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(sec => sec?.sectionName === "Perks")?.subSections?.subSection?.find(sec => sec?.sectionType === "Perks")?.products;
    setCloudStepDown(
      (buildProduct?.isCloudStepDownEnabled || true)
      && (perkOnView?.id === "R3552" || perkOnView === "R3553")
      && Array.isArray(profileCartPerks) && profileCartPerks?.findIndex(c => c?.prodId === "R3553") > -1
    );
  }, [perkOnView, props?.profileCart]);
  function handleToggle(e, product) {
    let add = selectedProduct?.includes(product?.perkDetails?.[0]?.id);
    const id = product?.perkDetails?.[0]?.id;
    // Apple product selection check
    if (!add && id === 'R3555') {
      const isAppleOneSelected = selectedPerks?.find((prod) => prod?.prodId === 'R3556' || prod?.prodId === 'R3557');
      setExisitngAppleProduct(isAppleOneSelected?.prodId || "");
      if (!!isAppleOneSelected) {
        setShowAppleModal(true);
        return;
      } else {
        setShowAppleInfoModal(true);
      }
    } else if (!add && (id === 'R3556' || id === 'R3557')) {
      const isAppleMusicSelected = selectedPerks?.find((prod) => prod?.prodId === 'R3555');
      setExisitngAppleProduct(isAppleMusicSelected?.prodId || "");
      if (!!isAppleMusicSelected) {
        setShowAppleModal(true);
        return;
      } else {
        setShowAppleInfoModal(true);
      }
    }

    const hasGroup = [constants.APPLE_ONE_INDIVIDUAL, constants.UNLIMITED_CLOUD_INDIVIDUAL, constants.HOME_DEVICE_ADVISOR].includes(product?.perkDetails?.[0]?.id)
    if (hasGroup && showDrawer[product?.perkDetails?.[0]?.id]?.drawer) {
      add = true;
      let prodId = selectedProduct?.split(',')?.find(item => perkOnView?.groupBy?.[0]?.split(',')?.includes(item));
      if (hasCloudStepDown && !cloudStepDownSubmitData && prodId === "R3553") {
        setCloudStepDownModalOpen(true);
        setCloudStepDownSubmitData({e: e, perkinfo: product});
        setCloudStepDownSource("Toggle");
        return;
      } else {
        setCloudStepDownSubmitData(null);
      }
      if (movesShowPerksOverlay && product?.perkDetails?.length === 2 && add) {
        const existingPerkFound = product?.perkDetails?.find(p => {
          return buildProduct?.perks?.selectedProduct?.find(selPerk => selPerk?.prodId === p?.id)
        })
        if (existingPerkFound && existingPerkFound?.id) {
          prodId = existingPerkFound?.id
        }
        setShowAppleInfoModal(false);
      }
     updatePerkSelection({ product, prodId, add, flowType, visitId, dispatch, isMnHAuthenticated, perkModalName, isStreamline });
    } else {
      updatePerkSelection({ product, add, flowType, visitId, dispatch, isMnHAuthenticated, perkModalName, isStreamline });
    }

    const key = product?.perkDetails?.[0]?.id;
    if ([constants.APPLE_ONE_INDIVIDUAL, constants.UNLIMITED_CLOUD_INDIVIDUAL, constants.HOME_DEVICE_ADVISOR].includes(product?.perkDetails?.[0]?.id)) {
      setShowDrawer({
        ...showDrawer,
        [key]: { "drawer": !showDrawer[product?.perkDetails?.[0]?.id]?.['drawer'], defaultValue: product?.perkDetails?.[0]?.id }
      });
    }
  }

  //Header Start

  let header = {
    title: {
      children: (
        <>
          {showLoader ? (
            <Loader active={true} surface="light" fullscreen={false} />
          ) : (
            "Plan total"
          )}{" "}
        </>
      ),
      primitive: "h2",
    },
    price: {
      price: (price ? isEmployee && perkOnView?.id == 'R3558' ? parseFloat(price, 2) / 2 : parseFloat(price, 2) - empDiscount : 0)?.toFixed?.(2)?.replace?.(/\.00$/, ''),
      uniformSize: true,
      size: "small",
    },
    savings: {
      price: discountedPrice,
      size: "small",
      uniformSize: true,
      trailingText: {
        children: "savings",
      },
    },
  };

  // Moves seamless customer Header changes
  if(movesShowPerksOverlay)
  {
    const movesprice = (price ? isEmployee && perkOnView?.id == 'R3558' ? parseFloat(price, 2) / 2 : parseFloat(price, 2) - empDiscount : 0)?.toFixed?.(2)?.replace?.(/\.00$/, '');
    header = {
      title: {
        children: (
          <>
            {showLoader ? (
              <Loader active={true} surface="light" fullscreen={false} />
            ) : (<>
              <Title size="large" primitive="h2" bold>
                {"Perk recommendations"}
              </Title>
              <div style={{marginTop:isMobile ? '8px' : '12px'}}>
              <Body size="large" primitive="p">                 
                <Description
                  dangerouslySetInnerHTML={{
                    __html: `${'Starting at'} $${movesprice}/mo` ,
                  }}
                />
              </Body>
              </div>
            </>
            )}{" "}
          </>
        ),
        primitive: "h3",
      }, 
      
           
     
    };
  }

  //Header End
  
  //Tile Start
  let tiles =
    perkList &&
      perkList?.map((product) => {
        let defaultProdId = "";
        const oldPricesArray = product?.perkDetails?.map(prod => (prod?.perkOriginalPrice - prod?.chargePrice + ((prod?.id == 'R3556' || prod?.id == 'R3557') && isEmployee ? prod?.chargePrice/2  :  empDiscount))?.toFixed(2));
        let perkActPrice = product?.perkDetails?.[0]?.perkOriginalPrice;
        const perkMrp = product?.perkDetails?.[0]?.productKeyword?.split?.('MRP:')?.[1];
        if (perkMrp && !(Array.isArray(oldPricesArray) && oldPricesArray?.length > 1)) {
          perkActPrice = parseFloat(perkMrp?.split('|')?.[0]);
        }
      const homeDevice = (product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR);
      const applesOneIndividual = (product?.perkDetails?.[0]?.id === constants.APPLE_ONE_INDIVIDUAL);
      let applesOneIndividualNewPrice = '';
      if(applesOneIndividual) {
        const applesOneIndividualPerkPrice1 = isEmployee ? product?.perkDetails?.[0]?.price/2 : product?.perkDetails?.[0]?.price;
        if(InHomeUtils.isNotEmpty(product?.perkDetails?.[1]?.id)){
          const gapplesOneIndividualPerkPrice2 = isEmployee && product?.perkDetails?.[1]?.id !== 'R3784' ? product?.perkDetails?.[1]?.price/2 : product?.perkDetails?.[1]?.price;
          applesOneIndividualNewPrice = applesOneIndividualPerkPrice1 + ' - $' + gapplesOneIndividualPerkPrice2
        }
      }  
      const unlimitedCloudStorage = (product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL);
      let subscriptionGroupPrice =  selectedProduct?.includes(product?.perkDetails?.[0].id) ? product?.perkDetails?.[0]?.price : product?.perkDetails?.[1]?.price 
      let elementBg =
        product?.perkDetails?.[0]?.perkTextAppearance?.toLowerCase() == "light"
          ? "dark"
          : "light";
      let tileObj = {
        backgroundImage: {
          baseUrl: "https://ss7.vzw.com/is/image/VerizonWireless/",
          perkName: product?.perkDetails?.[0]?.backgroundImage,
        },
        variant: variant,
        ariaLabel: product?.perkDetails?.[0]?.displayName,
        elementSurface: elementBg,
        title: {
          children: product?.perkDetails?.[0]?.displayName,
          type: "title",
          underline: isStreamline ? false : true,
        },
        ...(!homeDevice && {oldPrice: {
          price:  Array.isArray(oldPricesArray) && oldPricesArray?.length > 1
          ? Math.max(...oldPricesArray)
          : `${(
            perkActPrice - (isEmployee ? parseFloat(product?.perkDetails?.[0]?.chargePrice)/2 : product?.perkDetails?.[0]?.chargePrice)
          )?.toFixed(2)?.replace(/\.00$/, '')}`,
          term: "month",
        }}),
        ...(homeDevice && { oldPrice: {
          price: isEmployee ? '10' : '5',
          leadingText: {
            children: isStreamline ? "Save" :"Save up to"
          },
          term: 'month'
        }}),
        ...(unlimitedCloudStorage && { oldPrice: { 
          price: isEmployee ? '8.99' : isStreamline ? selectedProduct?.includes(product?.perkDetails?.[0].id) ? '3.99' : '4.99' : '3.99',
          leadingText: {
            children: 'Save'
          },
          term: 'month'
        }}),
        ...(applesOneIndividual && { oldPrice: {
          price: selectedProduct?.includes(product?.perkDetails?.[0].id) ? '9.95' : '5.95',
          leadingText: {
            children: isStreamline ? "Save" : "Save up to"
          },
          term: 'month'
        }}),
        newPrice: {
          price: homeDevice ? (isEmployee ? '5 - $25' : isStreamline && selectedGrpPerkId ? subscriptionGroupPrice :'10 - $25') : unlimitedCloudStorage ? (isEmployee ? '5 - $7.5' : isStreamline && selectedGrpPerkId ? subscriptionGroupPrice : '10 - $15') : applesOneIndividual ? isStreamline && selectedGrpPerkId ? subscriptionGroupPrice : applesOneIndividualNewPrice : (isEmployee && product?.perkDetails?.[0].id == 'R3558' ? (product?.perkDetails?.[0]?.chargePrice / 2) : (parseInt(product?.perkDetails?.[0]?.chargePrice) - empDiscount)),
          term: "month",
        },
        image: {
          src: product?.perkDetails?.[0]?.perkLogo,
          // size: 'small',
          alt: product?.perkDetails?.[0]?.name,
        },
        toggle: {
          // disabled: isToggleDisabled ? true : false,
          on: selectedProduct?.includes(product?.perkDetails?.[0].id) || selectedProduct?.includes(product?.perkDetails?.[1]?.id) || showDrawer[product?.perkDetails?.[0].id]?.drawer,
          onChange: (e) => {
            handleToggle(e, product);
            /*
            let add = selectedProduct?.includes(product?.perkDetails?.[0].id);
            const id = product?.perkDetails?.[0].id;
            // Apple product selection check
            if (!add && id === 'R3555') {
              const isAppleOneSelected = selectedPerks?.find((prod) => prod.prodId === 'R3556' || prod.prodId === 'R3557');
              setExisitngAppleProduct(isAppleOneSelected?.prodId || "");
              if (!!isAppleOneSelected) {
                setShowAppleModal(true);
                return;
              } else {
                setShowAppleInfoModal(true);
              }
            } else if (!add && (id === 'R3556' || id === 'R3557')) {
              const isAppleMusicSelected = selectedPerks?.find((prod) => prod.prodId === 'R3555');
              setExisitngAppleProduct(isAppleMusicSelected?.prodId || "");
              if (!!isAppleMusicSelected) {
                setShowAppleModal(true);
                return;
              } else {
                setShowAppleInfoModal(true);
              }
            }

            const hasGroup = [constants.APPLE_ONE_INDIVIDUAL,constants.UNLIMITED_CLOUD_INDIVIDUAL,constants.HOME_DEVICE_ADVISOR].includes(product?.perkDetails?.[0].id)
            if(hasGroup && showDrawer[product?.perkDetails?.[0].id].drawer){
              add = true;
              let prodId = selectedProduct?.split(',').find(item=> perkOnView.groupBy?.[0].split(',').includes(item));
              updatePerkSelection({product,prodId, add, flowType, visitId, dispatch,isMnHAuthenticated, perkModalName});
            }else{
              updatePerkSelection({product, add, flowType, visitId, dispatch,isMnHAuthenticated, perkModalName});
            }
          
            const key = product?.perkDetails?.[0].id
            if([constants.APPLE_ONE_INDIVIDUAL,constants.UNLIMITED_CLOUD_INDIVIDUAL,constants.HOME_DEVICE_ADVISOR].includes(product?.perkDetails?.[0].id)){
              setShowDrawer({
                ...showDrawer,
                [key]:{"drawer":!showDrawer[product?.perkDetails?.[0].id]['drawer'],defaultValue:product?.perkDetails?.[0].id}
              });
            }
            */
          },
          controlled: true
        }
      };
    // The below changes are for the group Perks Unlimited Cloud and Apple One Drawer funtionality.
    if(product?.perkDetails?.[0].id === constants.APPLE_ONE_INDIVIDUAL || 
      product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL ||
      product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR 
    ){
      const empPrice = isEmployee ? product?.perkDetails?.[0]?.price/2 : 0;
      const groupPerkPrice = isEmployee ? product?.perkDetails?.[0]?.price/2 : product?.perkDetails?.[0]?.price;
      console.log("perkDetailsperkDetails",product?.data?.drawer)
      if(selectedProduct?.includes(product?.perkDetails?.[0].id)){
        defaultProdId = product?.perkDetails?.[0].id;
      }
      let addRadioButtonGroup= [{
        name: product?.perkDetails?.[1]?.id,
        value: product?.perkDetails?.[0]?.id,
        label: <span className="GroupLabelWrapper-VDS" style={{ fontWeight: selectedProduct?.includes(product?.perkDetails?.[0].id) ? "bold" : "normal"}} >{`$${groupPerkPrice}/mo ${RadioButtonlabel[product?.perkDetails?.[0]?.id]}`}</span>,
        children:<><div> <Pricing color="green" size="small"  leadingText={{"children": "Save"}} price={`${(
         product?.perkDetails?.[0]?.perkOriginalPrice - product?.perkDetails?.[0]?.chargePrice + empPrice).toFixed(2)}`} term="month" />
      </div>
      {((product?.perkDetails?.[0]?.chargePrice !== '15.0' && product?.perkDetails?.[0]?.id ==="R3556") && (buildProduct?.enablePerkRedesign && isStreamline)) &&
        (<Notification type="info"
        id ={"appleNotification"}
        title={ReactHtmlParser(`<span style= "font-weight:400;font-size: .875rem;">Apple One Individual increases to $15/mo on April 17.</span>`)}
        fullBleed={true}
        inline={false}
        disableFocus={true}
        hideCloseButton = {true}></Notification>
        )}
        </>
      }];
       // Add only if the second radio button group their.
       if(InHomeUtils.isNotEmpty(product?.perkDetails?.[1]?.id)){
        if(selectedProduct?.includes(product?.perkDetails?.[1]?.id)){
          defaultProdId = product?.perkDetails?.[1]?.id;
        }
        const empPrice2 = isEmployee ? product?.perkDetails?.[1]?.price/2 : 0;
        const grpPerk2 = isEmployee && product?.perkDetails?.[1]?.id !== 'R3784' ? product?.perkDetails?.[1]?.price/2 : product?.perkDetails?.[1]?.price;
         addRadioButtonGroup.push(
         {
          name:  product?.perkDetails?.[1]?.id,
          value: product?.perkDetails?.[1]?.id,
          selected:true,
          ariaLabel: product?.perkDetails?.[1]?.id === "R3784"?`${product?.perkDetails?.[1]?.price}/mo Verizon 
          Home Device Protect`:'',
          label: <span className="GroupLabelWrapper-VDS" style={{ fontWeight: selectedProduct?.includes(product?.perkDetails?.[1].id) ? "bold" : "normal"}}>{`$${grpPerk2}/mo ${RadioButtonlabel[product?.perkDetails?.[1]?.id]}`}</span>,
          children: <>
                {product?.perkDetails?.[1]?.id !== "R3784" && <div>
                <Pricing color="green" size="small" leadingText={{"children": "Save"}} price={`${(
                      product?.perkDetails?.[1]?.perkOriginalPrice - product?.perkDetails?.[1]?.chargePrice + empPrice2).toFixed(2)}`} 
                      term="month" />
                      {product?.perkDetails?.[1]?.id === "R3553" ? "Includes up to 5 people" : "Add up to 5 other people"}
                </div>
                }
               </>
        }
       )
       }
        
       if(buildProduct?.enablePerkRedesign && isStreamline){
        streamdrawer= <>
        <div className={isStreamline ? "perkModalChooseUrSubscription" : ""}>Choose your subscription</div>
        <div className={`${"perkDrawer"} ${isStreamline ? "perkModalRadioGrpBtnStreamline" : ""}`} style={{"padding-bottom": "55px","padding-top":"10px"}}>
          <RadioButtonGroup 
          onChange={(e) => {handleRadioBtnChange(e, addRadioButtonGroup)}}
          defaultValue={defaultProdId}
          data={addRadioButtonGroup} 
          ariaLabel={`${product?.perkDetails?.[0]?.displayName} group option`}
          />
          </div> </>       
      }else{
       tileObj.drawer ={
        open: showDrawer[product?.perkDetails?.[0].id]['drawer'],
        children: 
       <div className="perkDrawer">
        <RadioButtonGroup 
        onChange={(e) => {handleRadioBtnChange(e, addRadioButtonGroup)}}
        defaultValue={showDrawer[product?.perkDetails?.[0].id]['defaultValue']}
        data={addRadioButtonGroup} 
        ariaLabel={`${product?.perkDetails?.[0]?.displayName} group option`}
        />
        </div>
      }}
    }
    return tileObj;
    });
  //Tile End

    const handleRadioBtnChange = async(e, labelObj) =>{
    console.log("handleRadioBtnChange", e)
    const selectedProduct = props?.selectedProduct?.split(",") || [];
    const initalPerkDetails = initialPerk && initialPerk.perkDetails && Array.isArray(initialPerk.perkDetails) ? initialPerk.perkDetails : [];
    let prodId = selectedProduct?.find(item=> (initalPerkDetails?.[0] && initalPerkDetails[0].id && initalPerkDetails[0].id === item)||(initalPerkDetails?.[1] && initalPerkDetails[1].id && initalPerkDetails[1].id === item));
    let filterLable = labelObj?.filter((p)=>p?.value===e.target.value)
    let toggeleLable = filterLable[0]?.label?.props['children']
    // for Group options We have to remove exisitng perk from the cart and add a new one on radio button changes.
    let add = true;
    if (hasCloudStepDown && !cloudStepDownSubmitData && prodId === "R3553") {
      setCloudStepDownModalOpen(true);
      setCloudStepDownSubmitData({e, labelObj});
      setCloudStepDownSource("Radio");
      return;
    } else {
      setCloudStepDownSubmitData(null);
    }
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart"} }) 
    let product = perkOnView;
      if (movesShowPerksOverlay && uniqPerkList?.length > 0 && e?.target?.value) {
        let groupPerks = ""
        for (const itm of uniqPerkList) {
          groupPerks = itm?.perkDetails;
          if (groupPerks?.length > 1) {
            const removedGroupPerk = groupPerks?.find(i => i?.id !== e?.target?.value)
            const selectedGroupPerk = groupPerks?.find(i => i?.id === e?.target?.value)
            if (selectedGroupPerk && removedGroupPerk && removedGroupPerk?.id) {
              prodId = removedGroupPerk?.id
              break
            }
          }
        }
      }
    await updatePerkSelection({product,prodId, add, flowType, visitId, dispatch,isMnHAuthenticated, isStreamline });
    setTimeout(()=>{
      add = false;
      prodId = e.target.value;
      updatePerkSelection({product,prodId, add, flowType, visitId, dispatch,isMnHAuthenticated, isStreamline});
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false,isLoaderText: "Updating your cart" } }) 
      const obj = {dawer:true,defaultValue:prodId}
    },500);
    updateSCTags(toggeleLable)
  }

  //Title Start

  let title;
  if (featuresDetailsList && featuresDetailsList?.length > 0) {
    title = {
      children: <>
      {
        perkOnViewId == constants.DISNEY_BUNDLE && buildProduct?.isDisneyPromoPresent && (disneyEligiblePlans?.indexOf(buildProduct?.internet?.selectedProduct?.id) > -1) 
        ? <>
            <Tilelet
                id='disney_perk_modal'
                title={{
                  size: 'bodyMedium',
                  children: <>
                    Special offer
                  </>,
                  primitive: 'h1',
                }}
                subtitle={{
                  size: 'bodyMedium',
                  children: <>
                    Get the Disney bundle on us for 12 months.  {getDisneyPromoDts()}
                  </>,
                  primitive: 'span',
                }}
                surface='light'
                width='442px'
                height='145px'
                backgroundColor='gray'
                textPosition='middle'
                textAlignment='left'
              />
            <br />
          </>
        : <></>
      }
      {
       buildProduct?.enablePerkRedesign && isStreamline  && (props?.selectedProductId === "R3556" || props?.selectedProductId === "R3731" || props?.selectedProductId === "R3552") && (selectedProduct?.includes(selectedProductRadio?.[0]?.id) || selectedProduct?.includes(selectedProductRadio?.[1]?.id))?<>{streamdrawer}</>:<></>
      }
        What's included 
      </>,
      primitive: "h3",
    };
    perkOverlayObj.title = title;
  } else {
    let tileItem =
      titles &&
      titles?.length > 0 &&
      titles?.find(
        (item) =>
          item && item?.displayName && item?.displayName == whatsIncludedKey
      );
    if (tileItem && tileItem.description) {
      title = {
        children: (
          <>
            <Title size="large" primitive="h3" bold>
              {"What's included"}
            </Title>
            <Body size="large">
              <br aria-hidden='true' />
              <Description
                dangerouslySetInnerHTML={{
                  __html: tileItem && tileItem?.description,
                }}
              />
            </Body>
          </>
        ),
        primitive: "p",
      };
      perkOverlayObj.title = title;
    }
  }

  let perkDesc = [];
  let aboutDesc = {};

  if (aboutText != "") {
    aboutDesc.title = {
      children: "About",
    };
    aboutDesc.children = aboutText;
  }
  aboutDesc && perkDesc?.push(aboutDesc);

  titles &&
    titles?.length > 0 &&
    titles?.forEach((item) => {
      if (item && item?.displayName && item?.displayName != whatsIncludedKey) {
        let itemObj = {};

        itemObj.title = {
          children: item?.displayName,
          primitive: "h3",
        };
        itemObj.children = (
          <ListElement
            dangerouslySetInnerHTML={{ __html: item?.description }}
          />
        );
        itemObj && perkDesc && perkDesc?.push(itemObj);
      }
    });

  //Title end

  //Table Start
  let table = {
    ariaLabel:"Apple One",
    head: {
      headers: [
        {
          children: (
            <div></div>
          ),
          pricing: {
            term: "none",
            hideCurrency: true
          }
        },
        {
          children: "Individual",
          pricing: {
            price: "15",
            term: "month",
          },
        },
        {
          children: "Family",
          pricing: {
            price: "20",
            term: "month",
          },
        },
      ],
    },
    body: {
      rows: [
        {
          cells: [
            {
              children: "Apple Music",
              renderAsHeader:true,
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
          ],
        },
        {
          cells: [
            {
              children: "Apple TV+",
              renderAsHeader:true,
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
          ],
        },
        {
          cells: [
            {
              children: "Apple Arcade",
              renderAsHeader:true,
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
            {
              children: (
                <AlternateCheckmark size="medium" surface="light" />
              ),
            },
          ],
        },
        {
          cells: [
            {
              children: "iCloud+",
              renderAsHeader:true,
            },
            {
              children: "50GB",
            },
            {
              children: "200GB",
            },
          ],
        },
        {
          cells: [
            {
              children: "Sharable",
              renderAsHeader:true,
            },
            {
              children: <Minus size="medium" surface="light" />,
            },
            {
              children: "With up to 5 other people",
            },
          ],
        },
      ],
    },
  };

  // Table End

  //List start

  let featureIncludedList;
  if (perkOnView?.featuresDetailsList?.length > 0) {
    featureIncludedList = featuresDetailsList?.map((val) => {
      console.log("@val", val);
      return {
        title: {
          children: val?.displayName,
        },
        children: (
          <Description
            dangerouslySetInnerHTML={{ __html: val && val?.description }}
          />
        ),
        image: {
          showBorder: false,
          src: props?.selectedProductId === "R3731" ?"https://www.verizon.com/content/dam/verizon/personal/accordion-images/banners/VerizonGiftCard.jpg" : val?.imageUrl,
          alt: "Netflix logo",
        },
      };
    });
  }

  const list = {
    data: featureIncludedList,
  };

  //list end

  //Saving Start
  let savings = {
    title: {
      children: "Exclusive Verizon savings",
      primitive: "h3",
    },
    lists: [
      {
        items: [
          {
            children: perkOnView ? perkOnView?.displayName : props?.perkListobj?.[props?.selectedProductId]?.data?.displayName,
            pricing: {
              price: perkOriginalPrice ? parseFloat(perkOriginalPrice, 2) : "",
              term: "month",
            },
          },
          {
            children: "You pay",
            bold: true,
            pricing: {
              price: (price ? isEmployee && perkOnView?.id == 'R3558' ? parseFloat(price, 2) / 2 : parseFloat(price, 2) - empDiscount : "0")?.toFixed?.(2)?.replace?.(/\.00$/, ''),
              term: "month",
            },
          },
          {
            children: "You save",
            bold: true,
            color: "green",
            pricing: {
              price: discountedPrice ? parseFloat(discountedPrice, 2) : "",
              term: "month",
            },
          },
        ],
      },
    ],
  };

  //Saving End

  //Media Start

  const mediaObj = {
    showBorder: true,
    video: {
      image: {
        src: posterImage,
        alt: "poster-image",
        ariaLabel: "Play video",
        "data-track": "play video",
      },
      src: videoUrl,
      controls: true,
      alt: "Image",
    },
  };

  //Media End

  //TnC Accordion Start

  const termsAccordion = termsAndConditions
    ? {
      list: [
        {
          header: {
            title: {
              children: "Terms and conditions",
              primitive: "h3",
            },
          },
          content: {
            children: termsAndConditions ? (
              <Description
                dangerouslySetInnerHTML={{ __html: termsAndConditions }}
              />
            ) : (
              ""
            ),
          },
        },
      ],
    }
    : null;

  //TnC Accordion End

  // FAQ start

  const faqDetails =
    faqList &&
    faqList?.map((faq) => {
      let obj = {};
      obj.header = {
        title: {
          children: faq?.title,
          ariaHidden: true,
          primitive: "h3",
        },
      };
      obj.content = {
        children: (
          <Description dangerouslySetInnerHTML={{ __html: faq?.description }} />
        ),
        ariaHidden: true,
      };

      return obj;
    });

  const faqAccordion = {
    title: {
      children: "Have questions? We've got answers",
      primitive: "h3",
    },
    list: faqDetails,
    type: "single",
  };

  const movesSeamlessBtnTxtcheck = (checkNewPerksMvSeamless(props?.profileCart?.cartData?.[0]?.perks?.perks, props?.cart?.cartData?.[0]?.perks?.perks) || props?.movesPerkFlow === "OSI"); 

  //Button Group starts
  const buttongroupDetails = {
    childWidth: '100%',
    alignment: isMobile ? 'center' :'left',
    surface: 'light',
    rowQuantity: { desktop: 2 },
    data: [
      {
        children: movesSeamlessBtnTxtcheck ? "Continue" : 'Skip and Continue',
        size: 'large',
        use: 'primary',
        width: isMobile ? "95vw" : 'auto',
        id:movesSeamlessBtnTxtcheck?'moveupsellcontinue':'moverupsellskipandcontinue',
        onClick: () => { props?.handleMovePerksBtn(movesSeamlessBtnTxtcheck ? "Continue" : 'Skip and Continue') }
      }
    ],
  
  };

  //button group ends

  

  perkOverlayObj.header = (buildProduct?.enablePerkRedesign && isStreamline)?'': header;
  perkOverlayObj.tiles = tiles;
  (perkOnViewId == constants?.APPLE_ONE_INDIVIDUAL ||
    perkOnViewId == constants?.APPLE_ONE_FAMILY) &&
    (perkOverlayObj.table = table);
  perkOverlayObj.list = list;
  perkOverlayObj.savings = savings;
  videoUrl != "" && (perkOverlayObj.media = mediaObj);
  perkOverlayObj.selectedIndex = perkIndex;
  perkOverlayObj.description = perkDesc;
  perkOverlayObj.accordion = termsAccordion;
  perkOverlayObj.faq = faqAccordion;
  perkOverlayObj.onChange = (e, defaultValue) => {
    onChangeSlide(defaultValue);
  };

  if(movesShowPerksOverlay){
    perkOverlayObj.buttonGroup = buttongroupDetails;
  }

  const modalPopUpBtnClick = async(newProductId, existingProdId) => {
    if (newProductId === existingProdId) {
      setShowAppleModal(false);
    } else {
      setShowAppleModal(false);
      await updatePerkSelection({prodId: existingProdId, add: true, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline});
      setTimeout(()=>{
        updatePerkSelection({prodId: newProductId, add: false, flowType, visitId, dispatch, isMnHAuthenticated, isStreamline});
      },500);
    }
  }

  return (
    <>
      { showAppleModal && (
        <AppleModal 
          prodId = {exisitngAppleProduct}
          onClose={() => {setShowAppleModal(false);}}
          onBtnClick = {(newProductId, existingProdId)=>{modalPopUpBtnClick(newProductId, existingProdId)}}
          onLinkClick = {(newProductId, existingProdId)=>{modalPopUpBtnClick(newProductId, existingProdId)}}
        />)
      }
      {showAppleInfoModal && (
        <Modal opened={true} disableOutsideClick={true} surface="light" fullScreenDialog={false} disableAnimation={false} ariaLabel="Apple device disclosure"  width={'35vw'}>
          <ModalTitle>
            Important information
          </ModalTitle>
          <ModalBody>
            <p>To start enjoying this product, you must have an iPhone with iOS 16.0 or later, an iPad with iPadOS 16.0 or later, or a Mac with macOS 13.1 (Ventura) or later.</p>
            <Button size="100" primary={true} id="apple-disclosure-accept" width="100" onClick={() => setShowAppleInfoModal(false)}>Got it</Button> 
          </ModalBody>
        </Modal>
      )}
      {hasCloudStepDown &&
        <CloudStepDownModal
          opened={isCloudStepDownModalOpen}
          source={cloudStepDownSource}
          onOpenedChange={(opened) => setCloudStepDownModalOpen(opened)}
          onCancel={() => setCloudStepDownSubmitData(null)}
          onSubmit={(e) => {
            if (cloudStepDownSource === "Toggle") {
              handleToggle(cloudStepDownSubmitData?.e, cloudStepDownSubmitData?.perkinfo);
            } else {
              handleRadioBtnChange(cloudStepDownSubmitData?.e, cloudStepDownSubmitData?.labelObj)
            }
          }}
          perkDetails={perkOnView}
        />
      }
      {showModal ? (
        <PerkDetailModal
          surface="light"
          opened={showModal}
          {...perkOverlayObj}
          onOpenedChange={(e) => {
            onOpenedChange(e);
          }}
        />
      ) : null}
    </>
  );
}

// const mapStateToProps = state => {
//   return {
//     buildProduct: state.buildProduct,
//     visitId: state.app.visitId,
//     cart: state.cart,
//     save: state.save,
//     flowType: state.app.flowType,
//     moveExp: state.moveExp.moveLandingExp,
//     isFCPflow: state.loopQual.isFCPflow,
//     isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
//     zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : '',
//     tarCode: state.loopQual.selectedState ? state.loopQual.lqResponse.tarcode : '',
//     cust_opt: state.moveExp.cust_opt,
//     isFcpInProfile: state.loopQual.isFcpInProfile,
//     lqState: state.loopQual
//   }
// }

export default PerkDetailOverlay;
// export default connect(mapStateToProps)(PerkDetailOverlay)
